import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';
import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';

var _templateObject = _taggedTemplateLiteral(['\n  display: flex;\n  flex-wrap: wrap;\n  padding: 10px 0px;\n  background-color: ', ';\n  opacity: ', ';\n  transition: opacity 0.2s;\n'], ['\n  display: flex;\n  flex-wrap: wrap;\n  padding: 10px 0px;\n  background-color: ', ';\n  opacity: ', ';\n  transition: opacity 0.2s;\n']);

import React, { PureComponent, Fragment } from 'react';
import { Tag, AddTagButton } from '../../..';
import styled from 'styled-components';
import Field from '../../components/Field';
import { styles, utils } from 'gipsy-misc';
import { tags as tagsApi } from 'gipsy-api';
import Icon from '../../../Icon';
import { default as AddTagForm } from './AddTagForm';
import injected from '../../../injected';

var Tags = function (_PureComponent) {
  _inherits(Tags, _PureComponent);

  function Tags(props) {
    var _this2 = this;

    _classCallCheck(this, Tags);

    var _this = _possibleConstructorReturn(this, (Tags.__proto__ || Object.getPrototypeOf(Tags)).call(this, props));

    _this.addTag = function (tag) {
      var data = {
        paramName: 'tags',
        value: tag,
        method: 'add'
      };

      _this.props.onChange(data);
    };

    _this.createAndAddTag = function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(tag) {
        var newTag;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return tagsApi.create(tag);

              case 3:
                newTag = _context.sent;

                _this.addTag(newTag);

                _this.setState({
                  creating: false,
                  newTagName: ''
                });
                _context.next = 11;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context['catch'](0);

                console.error(_context.t0);

              case 11:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[0, 8]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();

    _this.removeTag = function (tag) {
      var data = {
        paramName: 'tags',
        value: tag,
        method: 'remove'
      };
      _this.props.onChange(data);
      _this.deactivate();
    };

    _this.isAssignedToSelf = function () {
      var to = _this.props.to;

      return !to || injected.user.id == utils.user.getKey(to);
    };

    _this.activate = function () {
      var value = _this.props.value;


      var noTags = !value || value.length === 0;

      if (noTags && !_this.state.showInput) {
        _this.setState({ showInput: true });
      }
    };

    _this.deactivate = function () {
      _this.setState({ showInput: false });
    };

    _this.onCreateOption = function (optionValue) {
      _this.setState({ creating: true, newTagName: optionValue });
    };

    _this.state = {
      showInput: false,
      newTagName: ''
    };
    return _this;
  }

  _createClass(Tags, [{
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          isActive = _props.isActive,
          value = _props.value,
          isOpen = _props.isOpen,
          noPadding = _props.noPadding,
          label = _props.label,
          backgroundHover = _props.backgroundHover;
      var _state = this.state,
          showInput = _state.showInput,
          creating = _state.creating,
          newTagName = _state.newTagName;


      var randomColor = Math.floor(Math.random() * styles.colors.tagColors.length);

      var displayLabel = false;
      var displayTags = false;
      if (value && value.length > 0) {
        displayTags = true;
      } else if (!showInput && !creating) {
        displayLabel = true;
      }
      return React.createElement(
        Fragment,
        null,
        this.isAssignedToSelf() && React.createElement(
          Field,
          {
            className: 'tags-field row' + (isActive ? ' active' : '') + (isOpen ? ' open' : ''),
            noPadding: noPadding,
            backgroundHover: backgroundHover },
          React.createElement(
            'div',
            { className: 'row click-field gp-layout gp-row gp-space-between', onClick: this.activate },
            displayLabel && React.createElement(
              'div',
              { className: 'field-label' },
              React.createElement(Icon, { className: 'label-icon', icon: 'Tag' }),
              React.createElement(
                'span',
                { className: 'label-text' },
                label
              )
            ),
            React.createElement(
              Container,
              { noPadding: noPadding },
              displayTags && React.createElement(
                Fragment,
                null,
                value.sort(utils.tags.compareTags).map(function (tag) {
                  return React.createElement(Tag, {
                    key: tag.id,
                    id: tag.id,
                    name: tag.name,
                    color: tag.color,
                    backgroundColor: tag.backgroundColor,
                    mode: 'removable',
                    onRemove: _this3.removeTag,
                    style: { margin: '0px 5px 5px 0px' }
                  });
                }),
                !showInput && !creating && React.createElement(AddTagButton, { onClick: function onClick() {
                    return _this3.setState({ showInput: true });
                  } })
              ),
              showInput && React.createElement(AddTagForm, {
                onSelect: this.addTag,
                onCreate: this.createAndAddTag,
                onCreateOption: this.onCreateOption,
                taskTags: value,
                autofocus: true,
                onBlur: this.deactivate
              }),
              creating && React.createElement(Tag, {
                name: newTagName,
                color: styles.colors.tagColors[randomColor].color,
                backgroundColor: styles.colors.tagColors[randomColor].backgroundColor,
                mode: 'create',
                onCreate: this.createAndAddTag,
                onRemove: function onRemove() {
                  return _this3.setState({ creating: false });
                }
              })
            )
          )
        )
      );
    }
  }]);

  return Tags;
}(PureComponent);

var Container = styled.div(_templateObject, function (props) {
  return props.focus ? 'white' : '';
}, function (props) {
  return props.hide ? 0 : 1;
});

export default Tags;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-ui/lib/TaskPanel/fields/Tags/index.js
// module id = 495
// module chunks = 0